import React from 'react';

import { useTheme } from 'styled-components';

import { SearchInput, SearchInputMobile } from '@pkg/components';
import { useMedia } from '@pkg/hooks';

function GlobalSearch() {
    const theme = useTheme();
    const isDesktop = useMedia(`(min-width: ${theme.breakpoints.mobile})`);

    return isDesktop ? <SearchInput /> : <SearchInputMobile />;
}

export default GlobalSearch;
